const viewingTips = [
  {
    id: "tip-1",
    title: "按阶段推进，别跳着看",
    desc: "基础篇的内容会在进阶篇反复用到，基础不牢时跳到后面容易卡壳。",
  },
  {
    id: "tip-2",
    title: "每课看完先做小结",
    desc: "用一两句话记录这一课讲什么、解决了什么问题，后续复盘会轻松很多。",
  },
  {
    id: "tip-3",
    title: "配合自测清单检查",
    desc: "基础篇与进阶篇结束时各有一次自测，未达标的项目及时回看对应课程。",
  },
  {
    id: "tip-4",
    title: "用完整版做总复习",
    desc: "全部学完后，用完整版合辑快速过一遍，把零散记忆重新串成一条线。",
  },
];

const pageUsage = [
  { id: "u1", icon: "ri-filter-3-line", text: "「课程导航」支持按阶段筛选与关键词搜索。" },
  { id: "u2", icon: "ri-cursor-line", text: "点击课程卡片的「查看详情」，查看该课要点。" },
  { id: "u3", icon: "ri-anchor-line", text: "顶部导航的分区链接可直接跳转到对应内容。" },
  { id: "u4", icon: "ri-question-answer-line", text: "常见问题默认折叠，点击问题标题即可展开。" },
];

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
              Viewing guide
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              观看指南：让每一课都看得有价值
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
              目录只是起点，真正决定效果的是怎么用。下面几条是结合系列结构总结出的建议，
              适合大多数按顺序学习的用户参考。
            </p>

            <div className="mt-8 space-y-4">
              {viewingTips.map((tip, index) => (
                <div
                  key={tip.id}
                  className="flex items-start gap-4 rounded-lg bg-background-50 border border-background-200/70 p-4 md:p-5"
                >
                  <span className="font-heading font-black text-2xl md:text-3xl text-primary-400/80 w-9 text-center shrink-0">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                      {tip.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600 font-body">
                      {tip.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 lg:sticky lg:top-24">
              <h3 className="font-heading font-bold text-lg text-foreground-950">
                这个页面怎么用
              </h3>
              <ul className="mt-4 space-y-3">
                {pageUsage.map((item) => (
                  <li key={item.id} className="flex items-start gap-3">
                    <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={`${item.icon} text-base`}></i>
                    </span>
                    <span className="text-sm leading-relaxed text-foreground-700 font-body pt-1">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 pt-5 border-t border-background-200/70">
                <a
                  href="#lessons"
                  className="inline-flex w-full items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-compass-3-line"></i>
                  回到课程导航
                </a>
                <a
                  href="#catalog"
                  className="mt-2.5 inline-flex w-full items-center justify-center gap-2 px-5 py-3 rounded-md bg-secondary-100 text-secondary-900 text-sm font-label font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-list-check-2"></i>
                  再看一次目录总览
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}